module.exports = __webpack_public_path__ + "static/media/S3N8-5.05cea7de.svg";